module.exports = __webpack_public_path__ + "img/logo-endurobiking.5253ac1b.png";